<template>
	<Accessible
		name="deletemodal"
		trapped
		focusFirstItem
		autoFocus
		:wait="100"
		:tabOrder="[
			{ css: '.modal-close-btn', clickOnEnter: true },
			{ css: '.pronto-gray-pill-btn', clickOnEnter: true },
			{ css: '.pronto-red-pill-btn', clickOnEnter: true },
		]"
	>
		<StandardModal
			open
			:title="title"
			:confirmText="$t(confirmText)"
			:confirmProps="{ disabled, danger: true, loading: isProcessing }"
			@confirm="onDelete"
			@cancel="close"
			small
			ref="modal"
		>
			<div class="delete-modal-wrapper">
				<TrashCanIcon halo class="trash-logo" />
				<div class="help" :class="{ showConfirm }">
					{{ $t(bodyText) }}
				</div>

				<div v-if="showConfirm" class="confirm-check">
					<Checkbox v-model="confirmDelete" data-cy="confirm-check">
						{{ $t(checkboxText) }}
					</Checkbox>
				</div>
			</div>
		</StandardModal>
	</Accessible>
</template>

<script>
import { StandardModal, Checkbox } from './common'
import { TrashCanIcon } from '@/icons'
import Accessible from '@/components/common/Accessible'

export default {
	components: { StandardModal, TrashCanIcon, Accessible, Checkbox },
	props: {
		bodyText: String,
		confirmText: { type: String, default: 'chat_messageaction_delete' },
		isProcessing: { type: Boolean, default: null },
		showConfirm: { type: Boolean, default: null },
		title: String,
		checkboxText: { type: String, default: 'groupsettings_delete_understand' },
	},

	emits: ['close', 'delete'],

	data() {
		return {
			confirmDelete: false,
		}
	},

	computed: {
		disabled() {
			return this.showConfirm && !this.confirmDelete
		},
	},

	methods: {
		close() {
			this.$emit('close')
		},

		onDelete() {
			this.$emit('delete')
		},
	},
}
</script>

<style scoped lang="scss">
@import 'src/sass/variables';

.delete-modal-wrapper {
	@include flex-column-center;
	.trash-logo {
		color: var(--red-200);
		font-size: 58px;
	}

	.trash-logo,
	.help {
		margin-top: 24px;
	}

	.help.showConfirm {
		margin-top: 10px;
	}

	.help {
		@include fontFamily();
		color: var(--neutral-800);
		max-width: 400px;
		font-size: 16px;
		text-align: center;
	}

	.confirm-check {
		margin-top: 10px;
		.pronto-checkbox {
			@include fontFamily(800);
			font-size: 15px !important;
			color: var(--neutral-800);
		}
	}
}
</style>
